function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./integrations-slider-component.scss";
import IntegrationBadge from "../integration-badge/integration-badge-component";
import { MAX_INTEGRATIONS_FLOATING_WIDTH } from "segments/desktop/integrations/layouts/floating-integrations/constants";
import { ITEM_TOTAL_WIDTH, ITEM_TOTAL_HEIGHT, NUMBER_OF_ROWS } from "../../constants";
class IntegrationsSliderComponent extends PureComponent {
    componentDidMount() {
        this.animate();
    }
    render() {
        const { integrationBadges, className } = this.props;
        const containerClasses = classnames(className, "integrations-slider-component");
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + (containerClasses || ""),
            children: [
                integrationBadges.map((i, index)=>{
                    // X Position is translated to be absolute the index * width
                    const xPos = -1 * index * (ITEM_TOTAL_WIDTH / NUMBER_OF_ROWS) + MAX_INTEGRATIONS_FLOATING_WIDTH;
                    // Y Position will change whether it's odd or even accordingly
                    const yPos = index % 2 === 0 ? 0 : ITEM_TOTAL_HEIGHT;
                    return /*#__PURE__*/ _jsx("div", {
                        ref: (e)=>this.setItems(e, xPos, yPos),
                        className: `jsx-${componentStyles.__hash}` + " " + "integration-badge-wrapper",
                        children: /*#__PURE__*/ _jsx(IntegrationBadge, {
                            path: i.path
                        }, i.key)
                    }, `integration_${index}`);
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "animate", ()=>{
            const step = ()=>{
                window.requestAnimationFrame(step);
                this.itemRefs.forEach((item)=>{
                    item.xPos = item.xPos + 0.5;
                    if (item.xPos > this.size - ITEM_TOTAL_WIDTH) {
                        item.xPos -= this.size;
                    }
                    if (item.element) {
                        item.element.style.transform = `translate(${item.xPos}px, ${item.yPos}px)`;
                    }
                });
            };
            window.requestAnimationFrame(step);
        });
        _define_property(this, "setItems", (element, xPos, yPos)=>{
            this.itemRefs.push({
                element,
                xPos,
                yPos
            });
        });
        this.itemRefs = [];
        this.size = props.integrationBadges.length / NUMBER_OF_ROWS * ITEM_TOTAL_WIDTH;
    }
}
export { IntegrationsSliderComponent as default };
